export default __webpack_public_path__ + "static/bonnie-e6913b27eb2474076fc25988833acab2.png";